export const VIEWED_DOCUMENTS_KEY = 'backoffice.viewedDocuments';
